import { TAX_ID_DATA } from "common/taxConstants";

export function getTaxIdProps(countryCode: string): {
    show: boolean;
    name: string;
    placeholder: string;
    validate: (value: string) => boolean;
    type: string | null;
} {
    const taxIdData = TAX_ID_DATA.find(({ countryCode: taxIdCountryCode, isLocal }) => taxIdCountryCode.toLowerCase() === countryCode.toLowerCase() && !isLocal);
    if (!taxIdData) {
        return {
            show: false,
            name: "",
            placeholder: "",
            validate: () => true,
            type: null
        };
    }

    return {
        show: true,
        name: taxIdData.name,
        placeholder: taxIdData.placeholder,
        validate: value => !value || value.trim().length === taxIdData.placeholder.length,
        type: taxIdData.type
    };
}
